import React from 'react';
import { useLocation } from 'react-router-dom';
import { ClaimFilterBar } from '../../components/claims/claimFilterBar/claimFilterBar';
import { ClaimsPanel } from '../../components/claims/claimsPanel/claimsPanel';
import { NewClaimButton } from '../../components/claims/newClaim/newClaimButton/newClaimButton';
import Loading from '../../components/shared/Loading/Loading';
import { sortClaims } from '../../utils/sort';
import { useClaimsLogic } from './useClaimsLogic';
import './claims.scss';

export const Claims = () => {
  const { search } = useLocation();
  const logic = useClaimsLogic(search);

  const {
    petLoading,
    initialClaimsLoading,
    savedLoading,
    loadMoreLoading,

    petDetails,
    savedVisible,
    openClaims,
    completedClaims,

    savedHasMore,
    openHasMore,
    completedHasMore,

    panelFilter,
    setPanelFilter,
    policyFilter,
    setPolicyFilter,

    handleSavedShowMore,
    handleShowMore,

    PANEL_FILTERS,
    CLAIM_TYPES
  } = logic;

  return (
    <main
      className="myClaims"
      aria-label="My Claims page"
    >
      <h1 className="mainPageHeader">My claims</h1>

      <div className="myClaimsHeader">
        {petLoading ? (
          <Loading />
        ) : (
          <ClaimFilterBar
            petDetails={petDetails}
            policyFilter={policyFilter}
            claimPanelFilter={panelFilter}
            onClaimFilterChange={(e) => setPanelFilter(e.target.value)}
            onPetFilterChange={(e) => setPolicyFilter(e.target.value)}
          />
        )}
        <NewClaimButton />
      </div>

      {(panelFilter === PANEL_FILTERS.ALL || panelFilter === PANEL_FILTERS.SAVED) &&
        (savedLoading ? (
          <Loading />
        ) : (
          <ClaimsPanel
            icon="save"
            headingText="My saved claims"
            petDetails={petDetails}
            claims={savedVisible}
            filter={policyFilter}
            includeCompleteButton
            includeDeleteButton
            onShowMore={handleSavedShowMore}
            showMoreAvailable={savedHasMore}
            isLoading={false}
          />
        ))}

      {(panelFilter === PANEL_FILTERS.ALL || panelFilter === PANEL_FILTERS.OPEN) &&
        (initialClaimsLoading ? (
          <Loading />
        ) : (
          <ClaimsPanel
            headingText="My open claims"
            petDetails={petDetails}
            claims={sortClaims(openClaims)}
            filter={policyFilter}
            onShowMore={() => handleShowMore(CLAIM_TYPES.OPEN)}
            showMoreAvailable={openHasMore}
            isLoading={openHasMore && loadMoreLoading}
          />
        ))}

      {(panelFilter === PANEL_FILTERS.ALL || panelFilter === PANEL_FILTERS.COMPLETED) &&
        (initialClaimsLoading ? (
          <Loading />
        ) : (
          <ClaimsPanel
            headingText="My completed claims"
            petDetails={petDetails}
            claims={sortClaims(completedClaims)}
            filter={policyFilter}
            onShowMore={() => handleShowMore(CLAIM_TYPES.COMPLETED)}
            showMoreAvailable={completedHasMore}
            isLoading={completedHasMore && loadMoreLoading}
          />
        ))}
    </main>
  );
};
